import React from 'react';
import { Box, TextField, FormControlLabel, Switch } from '@mui/material';
import type { TennisSettings } from '@/types';
import type { SportSettingsFormProps } from './types';
import { SettingsSection } from './SettingsSection';
import { SettingsField, SettingsFieldsGrid } from './SettingsFieldsGrid';

export const TennisSettingsForm: React.FC<SportSettingsFormProps> = ({ value, onChange, disabled }) => {
  const s = value as TennisSettings;
  const upd = (patch: Partial<TennisSettings>) => onChange({ ...s, ...patch });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

      <SettingsSection title="Структура матча">
        <SettingsFieldsGrid>
          <SettingsField>
            <TextField label="Сетов в матче" type="number" size="small" fullWidth
              value={s.sets ?? 3}
              onChange={(e) => upd({ sets: parseInt(e.target.value) || 3 })}
              slotProps={{ htmlInput: { min: 1, max: 5, step: 2 } }}
              helperText="Обычно 3 или 5"
              disabled={disabled} />
          </SettingsField>
          <SettingsField>
            <TextField label="Тай-брейк при счёте x:x" type="number" size="small" fullWidth
              value={s.tiebreakAt ?? 6}
              onChange={(e) => upd({ tiebreakAt: parseInt(e.target.value) || 6 })}
              slotProps={{ htmlInput: { min: 4 } }}
              disabled={disabled} />
          </SettingsField>
        </SettingsFieldsGrid>
      </SettingsSection>

      <SettingsSection title="Правила">
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap', gap: 1 }}>
          <FormControlLabel
            control={<Switch checked={s.finalSetTiebreak ?? false}
              onChange={(e) => upd({ finalSetTiebreak: e.target.checked })} disabled={disabled} />}
            label="Тай-брейк в финальном сете"
          />
          <FormControlLabel
            control={<Switch checked={s.superTiebreak ?? false}
              onChange={(e) => upd({ superTiebreak: e.target.checked })} disabled={disabled} />}
            label="Матч-тай-брейк (10 очков)"
          />
          <FormControlLabel
            control={<Switch checked={s.noAd ?? false}
              onChange={(e) => upd({ noAd: e.target.checked })} disabled={disabled} />}
            label="No-advantage (ровно = 1 розыгрыш)"
          />
        </Box>
      </SettingsSection>

      <SettingsSection title="Очки в таблице">
        <SettingsFieldsGrid>
          <SettingsField>
            <TextField label="За победу" type="number" size="small" fullWidth
              value={s.pointsWin ?? 2}
              onChange={(e) => upd({ pointsWin: parseInt(e.target.value) })}
              slotProps={{ htmlInput: { min: 0 } }} disabled={disabled} />
          </SettingsField>
          <SettingsField>
            <TextField label="За поражение" type="number" size="small" fullWidth
              value={s.pointsLoss ?? 0}
              onChange={(e) => upd({ pointsLoss: parseInt(e.target.value) })}
              slotProps={{ htmlInput: { min: 0 } }} disabled={disabled} />
          </SettingsField>
        </SettingsFieldsGrid>
      </SettingsSection>

    </Box>
  );
};
